<template>
  <div class="modal-dialog modal-lg" :id="id">
    <div class="modal-content">
      <div class="avatar-form">
        <div class="modal-header">
        </div>
        <div class="modal-body">
          <div class="avatar-body">
            <el-row>
              <el-col :span="18">
                <div class="avatar-wrapper"></div>
              </el-col>
              <el-col :span="6" style="overflow: hidden;">
                <div style="padding-left: 10px">
                  <div class="avatar-preview preview-lg"></div>
                  <div class="avatar-preview avatar-preview-round preview-md"></div>
                </div>
              </el-col>
            </el-row>
            <!-- <el-row class="avatar-btns">
              <el-col :span="4">
                <div class="avatar-upload">
                  <input type="hidden" class="avatar-src" name="avatar_src">
                  <input type="hidden" class="avatar-data" name="ci">
                  <label :for="avatarInputId" class="el-button el-button--primary">选择图片</label>
                  <input type="file" class="avatar-input " style="visibility: hidden" :id="avatarInputId" :name="id">
                </div>
              </el-col>
              <el-col :span="10" id="rotateBtn">
                <el-button-group>
                  <button type="primary" class="el-button el-button--primary" data-method="rotate" data-option="45" title="Rotate 45 degrees">旋转45度</button>
                  <button type="primary" class="el-button el-button--primary" data-method="rotate" data-option="90" title="Rotate 90 degrees">旋转90度</button>
                  <button type="primary" class="el-button el-button--primary" data-method="rotate" data-option="180" title="Rotate 180 degrees">旋转180度</button>
                </el-button-group>
              </el-col>
              <el-col :span="6">
                <el-button-group>
                  <button type="primary" class="el-button el-button--primary" @click="cancelCropper"> 重 置 </button>
                  <button type="primary" class="el-button el-button--primary" @click="submit"> 上 传 </button>
                </el-button-group>
              </el-col>
              <el-col :span="4"></el-col>
            </el-row> -->
            <el-row>
              <div class="avatar-upload">
                <input type="hidden" class="avatar-src" name="avatar_src">
                <input type="hidden" class="avatar-data" name="ci">
                <input type="file" class="avatar-input " style="visibility: hidden" :id="avatarInputId" :name="id">
              </div>
            </el-row>
            <el-row>
              <div :class=" imgType=='headImg'? 'headImgBtnGroupClass' : 'wxQrcodeBtnGroupClass' ">
                <label :for="avatarInputId" class="eb-button-small el-button eb-button-group-btn eb-button-orange">选择图片</label>
                <el-button class="eb-button-group-btn eb-button-orange eb-button-small" @click="cancelCropper"> 重 置 </el-button>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  props: {
    id: String,
    imgType: String
  },
  data() {
    return {
      avatarInputId: '',
      $container: null,
      $avatarForm: null,
      $avatarUpload: null,
      $avatarSrc: null,
      $avatarData: null,
      $avatarInput: null,
      $avatarBtns: null,
      $avatarWrapper: null,
      $avatarPreview: null,
      support: {
        fileList: !!$('<input type="file">').prop('files'),
        blobURLs: !!window.URL && URL.createObjectURL,
        formData: !!window.FormData
      }
    };
  },
  created() {},
  mounted() {
    this.$container = $('#' + this.id);
    this.$avatarForm = this.$container.find('.avatar-form');
    this.$avatarUpload = this.$avatarForm.find('.avatar-upload');
    this.$avatarSrc = this.$avatarForm.find('.avatar-src');
    this.$avatarData = this.$avatarForm.find('.avatar-data');
    this.$avatarInput = this.$avatarForm.find('.avatar-input');
    this.$avatarWrapper = this.$container.find('.avatar-wrapper');
    this.$avatarPreview = this.$container.find('.avatar-preview');
    this.$avatarBtns = this.$container.find('#rotateBtn');
    this.$nextTick(function() {
      this.init();
    });
  },
  methods: {
    init: function() {
      this.support.datauri = this.support.fileList && this.support.blobURLs;
      this.avatarInputId = 'avatarInput' + this.id;
      this.addListener();
    },

    addListener: function() {
      this.$avatarInput.on('change', $.proxy(this.change, this));
      this.$avatarBtns.on('click', $.proxy(this.rotate, this));
    },
    initPreview: function() {
      let url = this.$avatar.attr('src');
      this.$avatarPreview.html('<img src="' + url + '">');
    },

    click: function() {
      this.initPreview();
    },
    change: function() {
      let files;
      let file;
      if (this.support.datauri) {
        files = this.$avatarInput.prop('files');
        if (files.length > 0) {
          file = files[0];
          if (this.isImageFile(file)) {
            if (this.url) {
              URL.revokeObjectURL(this.url); // Revoke the old one
            }
            this.url = URL.createObjectURL(file);
            this.startCropper();
          } else {
            this.$message.error('请选择图片文件.');
          }
        }
      }
    },
    // 裁剪提交
    submit: function() {
      if (!this.$avatarSrc.val() && !this.$avatarInput.val()) {
        this.$message.error('请选择要上传的图片文件！');
        return false;
      }
      if (this.support.formData) {
        this.ajaxUpload();
      }
    },
    // 旋转事件
    rotate: function(e) {
      let data;
      if (this.active) {
        data = $(e.target).data();
        if (data.method) {
          this.$img.cropper(data.method, data.option);
          return false;
        }
      }
    },
    isImageFile: function(file) {
      if (file.type) {
        return /^image\/\w+$/.test(file.type);
      } else {
        return /\.(jpg|jpeg|png|gif)$/.test(file);
      }
    },

    startCropper: function() {
      let _this = this;
      if (this.active) {
        this.$img.cropper('replace', this.url);
      } else {
        this.$img = $('<img src="' + this.url + '">');
        this.$avatarWrapper.empty().html(this.$img);
        this.$img.cropper({
          viewMode: 1,
          aspectRatio: 1,
          preview: this.$avatarPreview,
          restore: false,
          crop: function(e) {
            let json = [
              '{"x":' + e.x,
              '"y":' + e.y,
              '"height":' + e.height,
              '"width":' + e.width,
              '"rotate":' + e.rotate + '}'
            ].join();
            // 裁图参数存起来
            _this.$avatarData.val(json);
          }
        });
        this.active = true;
      }
    },
    ajaxUpload: function() {
      let imgData = JSON.stringify(this.$img.cropper('getData'));
      this.$emit('cropper-success', this.$avatarInput[0], imgData);
    },
    cancelCropper: function() {
      this.$img.cropper('reset');
    }
  },
  beforeDestroy() {
    this.$img.cropper('destory');
  }
};
</script>
<style  lang='less' scoped>
.avatar-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.avatar-body {
  padding-right: 15px;
  padding-left: 15px;
}
.avatar-upload {
  overflow: hidden;
}
.avatar-upload label {
  display: block;
  float: left;
  clear: left;
  width: 100px;
}
.avatar-upload input {
  display: block;
  margin-left: 110px;
}
.avatar-wrapper {
  height: 364px;
  width: 100%;
  margin-top: 15px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);
  background-color: #fcfcfc;
  overflow: hidden;
}
.avatar-wrapper img {
  display: block;
  height: auto;
  max-width: 100%;
}
.avatar-preview {
  float: left;
  margin-top: 15px;
  margin-right: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fff;
  overflow: hidden;
}
.avatar-preview:hover {
  border-color: #ccf;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
}
.avatar-preview img {
  width: 100%;
}
.avatar-preview-round {
  border-radius: 50%;
}
.preview-lg {
  height: 165px;
  width: 165px;
  margin-top: 15px;
}
.preview-md {
  height: 165px;
  width: 165px;
}
@media (min-width: 992px) {
  .avatar-preview {
    float: none;
  }
}
.avatar-btns {
  margin-top: 30px;
  margin-bottom: 15px;
}
.avatar-btns .btn-group {
  margin-right: 5px;
}
.headImgBtnGroupClass {
  width: 30%;
  margin-left: 38%;
  .el-button {
    display: inline-block;
    line-height: initial;
    text-align: center;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
.wxQrcodeBtnGroupClass {
  width: 30%;
  margin-left: 29%;
  .el-button {
    display: inline-block;
    line-height: initial;
    text-align: center;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
</style>
